// lib/gtag.ts
export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID || "";

// Send pageview events to Google Analytics
export const pageview = (url: string) => {
  if (typeof window !== "undefined" && GA_TRACKING_ID) {
    (window as any).gtag("config", GA_TRACKING_ID, { page_path: url });
  }
};

// Log specific events
export const event = ({
  action,
  category,
  label,
  value,
}: Record<string, string | number>) => {
  if (typeof window !== "undefined" && GA_TRACKING_ID) {
    (window as any).gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
